<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'neutral',
    validator: value => ['brand', 'neutral'].includes(value),
  },
});

const emit = defineEmits(['navigate']);

const surfaceClass = computed(() =>
  props.variant === 'brand'
    ? 'border-current/40 bg-[color-mix(in_srgb,currentColor_12%,transparent)] text-current hover:bg-[color-mix(in_srgb,currentColor_6%,transparent)] focus-visible:ring-current'
    : 'border-n-brand/60 bg-n-alpha-2 text-n-slate-12 hover:bg-n-alpha-3 focus-visible:ring-n-brand'
);
</script>

<template>
  <button
    type="button"
    class="flex w-full min-w-0 items-start gap-2 rounded-lg border-s-2 px-2.5 py-2 text-start transition-colors focus-visible:outline-none focus-visible:ring-2"
    :class="surfaceClass"
    @click="emit('navigate')"
  >
    <span class="i-lucide-reply mt-0.5 size-4 shrink-0" aria-hidden="true" />
    <span class="min-w-0 flex-1">
      <span class="block text-xs font-semibold leading-4 opacity-80">
        {{ label }}
      </span>
      <span
        class="mt-0.5 block line-clamp-3 whitespace-pre-line break-words text-sm leading-5"
      >
        {{ content }}
      </span>
    </span>
  </button>
</template>
